var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoAnswer = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9571 6.71291C20.5666 6.32238 19.9334 6.32238 19.5429 6.71291L11.0833 15.1725L4.45711 8.54624C4.06658 8.15572 3.43342 8.15572 3.04289 8.54624C2.65237 8.93676 2.65237 9.56993 3.04289 9.96045L10.3762 17.2938C10.7668 17.6843 11.3999 17.6843 11.7904 17.2938L20.9571 8.12712C21.3476 7.7366 21.3476 7.10343 20.9571 6.71291Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 7.42001C21.25 6.86773 20.8023 6.42001 20.25 6.42001H14.75C14.1977 6.42001 13.75 6.86773 13.75 7.42001C13.75 7.9723 14.1977 8.42001 14.75 8.42001H19.25V12.92C19.25 13.4723 19.6977 13.92 20.25 13.92C20.8023 13.92 21.25 13.4723 21.25 12.92V7.42001Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoAnswer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NoAnswer.b3d102b9a53998fe3e931d4b1081bcb0.svg";